module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2c"
  }, [_c('span', {
    staticClass: "pgref",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Preface#pre"
    }
  }, [_c('strong', [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("1")]), _vm._v(" INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-1"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("1.1")]), _vm._v(" The Physical Basis of Maxwell’s Equations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-2"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("1.2")]), _vm._v(" Maxwell’s Equations in Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("1.3")]), _vm._v(" The Mathematical Structure of Electrodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3-1"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("1.3.1")]), _vm._v(" Electrostatic Phenomena")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3-2"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("1.3.2")]), _vm._v(" Magnetostatic Phenomena")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3-3"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("1.3.3")]), _vm._v(" Wave Phenomena")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3-4"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("1.3.4")]), _vm._v(" The General Case")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter01#ch1-3-5"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("1.3.5")]), _vm._v(" The Mathematical Apparatus")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("2")]), _vm._v(" TIME-INDEPENDENT FIELDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("2.1")]), _vm._v(" Electrostatics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.1.1")]), _vm._v(" Method 1: Guesses and Symmetries")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.1.2")]), _vm._v(" Method 2: The Green Function")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-1-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.1.3")]), _vm._v(" Expansions with Orthonormal Functions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("2.2")]), _vm._v(" Magnetostatics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.2.1")]), _vm._v(" Method 1: The Magnetic Scalar Potential")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.2.2")]), _vm._v(" Method 2: The Magnetic Vector Potential")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter02#ch2-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("2.2.3")]), _vm._v(" Method 3: Hard Ferromagnets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("3")]), _vm._v(" GENERAL PROPERTIES OF MAXWELL’S EQUATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("3.1")]), _vm._v(" Time-Varying Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("3.2")]), _vm._v(" The Time-Dependent Green Function")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    staticClass: "pgref",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("3.3")]), _vm._v(" Conservation Laws")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("3.3.1")]), _vm._v(" Field Energy Density and Poynting’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("3.3.2")]), _vm._v(" Conservation of Linear Momentum")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("3.3.3")]), _vm._v(" The Maxwell Stress Tensor")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter03#ch3-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("3.3.4")]), _vm._v(" Conservation of Angular Momentum")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("4")]), _vm._v(" ELECTROMAGNETIC WAVES AND RADIATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.1")]), _vm._v(" Electromagnetic Waves")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.2")]), _vm._v(" Polarization and Stokes Parameters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.3")]), _vm._v(" Reflection and Refraction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.4")]), _vm._v(" Time Harmonic Fields in Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.5")]), _vm._v(" Wave Guides")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("4.6")]), _vm._v(" Radiation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-6-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("4.6.1")]), _vm._v(" Point Currents and Liénard-Wiechert Potentials")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-6-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("4.6.2")]), _vm._v(" The Radiation Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter04#ch4-6-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to3"
  }, [_vm._v("4.6.3")]), _vm._v(" Simple Radiating Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("5")]), _vm._v(" A NEED FOR THE SPECIAL THEORY OF RELATIVITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("5.1")]), _vm._v(" Basic Principles and Transformations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("5.2")]), _vm._v(" Mathematical Structure of Four-Dimensional Spacetime")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("5.3")]), _vm._v(" Lorentz Transformation Properties of Physical Quantities")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("5.4")]), _vm._v(" Lorentz Transformation of Macroscopic Electrodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter05#ch5-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("5.5")]), _vm._v(" Stress-Energy Momentum Tensor and Conservation Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("6")]), _vm._v(" THE LAGRANGIAN FORMULATION OF ELECTRODYNAMICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter06#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("6.1")]), _vm._v(" Action Principles in Classical Field Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter06#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("6.2")]), _vm._v(" Relativistic Lagrangians of Point-Charge Motions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter06#ch6-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("6.3")]), _vm._v(" The Field Lagrangian")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter06#ch6-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("6.4")]), _vm._v(" Invariances and Conservation Laws (Noether’s Theorem)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "pgref",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("7")]), _vm._v(" RELATIVISTIC TREATMENT OF RADIATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.1")]), _vm._v(" The Green Function in Four-Dimensional Spacetime")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.2")]), _vm._v(" Liénard-Wiechert Potentials and Fields for a Point Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.3")]), _vm._v(" Angular Distribution of the Emitted Radiation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.4")]), _vm._v(" Bremsstrahlung Radiation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.5")]), _vm._v(" Radiative Motions of a Point Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter07#ch7-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("7.6")]), _vm._v(" Radiation Damping and the Relativistic Lorentz-Dirac Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "to1"
  }, [_vm._v("8")]), _vm._v(" SPECIAL TOPICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.1")]), _vm._v(" Time-Independent Multipole Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.2")]), _vm._v(" Multipole Expansion of Time-Dependent Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.3")]), _vm._v(" Collisions between Charged Particles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.4")]), _vm._v(" Magnetohydrodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.5")]), _vm._v(" Alfvén Waves and Particle Acceleration")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.6")]), _vm._v(" Synchrotron Emission")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.7")]), _vm._v(" Echoes of the Big Bang")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.8")]), _vm._v(" Cosmic Superluminal Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Chapter08#ch8-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "to2"
  }, [_vm._v("8.9")]), _vm._v(" Polarized Radiation from the Black Hole at the Galactic Center")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_References#ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("REFERENCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226519586_Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDEX")])]), _c('span', {
    staticClass: "pgref",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b82c8c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226519586_Contents.vue
// module id = 66
// module chunks = 0